import { FC } from 'react';

import { Box, MenuItem as MenuItemMui, Select as SelectMui, styled, Typography } from '@mui/material';

import { ReactComponent as CheckIcon } from 'assets/icons/CheckIcon.svg';
import { ReactComponent as DropdownArrow } from 'assets/icons/DropdownArrow.svg';
import { ReactComponent as LockOutlinedIcon } from 'assets/icons/LockOutlinedIcon.svg';
import { ReactComponent as PlanetIcon } from 'assets/icons/PlanetIcon.svg';

import { ISelectProps } from './types';

import styles from './ChangeDocAccessSelect.module.scss';

import colors from 'styles/sass-variables.module.scss';

export const SelectStyled = styled(SelectMui)(() => ({
  '& .MuiInputBase-root ': {
    padding: '0',
  },
  '& .MuiSelect-select': {
    padding: '0 !important',
  },
  '& .MuiSelect-icon': {
    display: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: '0 !important',
    borderColor: 'transparent !important',
  },
}));

export const MenuItem = styled(MenuItemMui)(() => ({
  '& .Mui-selected': {
    backgroundColor: colors.primary_purple_100,
  },
}));

export const ChangeDocAccessSelect: FC<ISelectProps> = ({ value, onChange, options, isRestricted }) => (
  <SelectStyled
    defaultValue={options[0].value}
    className={styles.dropdownWrapper}
    value={value}
    onChange={onChange}
    MenuProps={{
      classes: {
        list: styles.selectWrapper,
      },
    }}
    renderValue={(value) => {
      const title = options.find(({ value: id }) => id === value)?.title;

      return (
        <Box className={styles.dropdownInput}>
          <Box className={styles.dropdownIcon}>{isRestricted ? <LockOutlinedIcon /> : <PlanetIcon />}</Box>
          <Typography className={styles.text} variant="body2">
            {title}
          </Typography>
          <DropdownArrow className={styles.dropdownArrow} />
        </Box>
      );
    }}
  >
    {options.map(({ value, title, text }) => (
      <MenuItem key={value} value={value} className={styles.menuItem}>
        {value === value && <CheckIcon className={styles.menuItemIcon} />}
        <Box className={styles.menuItemText}>
          <Typography variant="body2">{title}</Typography>
          <Typography variant="subtitle2" className={styles.text}>
            {text}
          </Typography>
        </Box>
      </MenuItem>
    ))}
  </SelectStyled>
);
